import { dispatchTrackingEvent } from ".";
import { FormRequestType } from "../leadAPIClient";
import { isSSR } from "../ssr";

export function getVisitorAuid(): string {
  try {
    if (!isSSR() && typeof window.get_auid !== "undefined")
      return window.get_auid();
    return "";
  } catch {
    return "";
  }
}

export function getMarketingCloudVisitorID(): string {
  try {
    if (
      !isSSR() &&
      window?._satellite &&
      typeof window._satellite.getVisitorId === "function"
    )
      return window?._satellite.getVisitorId()?.getMarketingCloudVisitorID();
    return "";
  } catch {
    return "";
  }
}

export function trackFormSubmitted(event: FormTrackingEvent): void {
  dispatchTrackingEvent("web-request-submitted", event);
}

export interface FormTrackingEvent {
  wrid: number;
  uwrid: string;
  request_type?: FormRequestType;
  brochure?: string;
  is_agent?: boolean;
  is_test?: boolean;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
export function pushToDataLayer(vals: any): void {
  if (!isSSR()) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(vals);
  }
}

interface VoyageToDataLayerInterface {
  name?: string;
  code?: string;
  departure_date?: string;
  arrival_date?: string;
  days_duration?: number;
  ship_name?: string;
  price?: number;
  sale_state?: string;
  suite?: string;
  departure_port?: string;
  arrival_port?: string;
  destination_id?: number;
  cruise_type?: string;
}
export function voyageToDataLayer(args: VoyageToDataLayerInterface): void {
  const {
    name,
    code,
    departure_date,
    arrival_date,
    days_duration,
    ship_name,
    price,
    sale_state,
    suite,
    departure_port,
    arrival_port,
    destination_id,
    cruise_type
  } = args;
  pushToDataLayer({
    voyage_details: {
      name,
      code,
      departure_date,
      arrival_date,
      days_duration,
      ship_name,
      price,
      sale_state: sale_state == "price" ? "active" : sale_state,
      suite,
      departure_port,
      arrival_port,
      destination_id,
      cruise_type
    }
  });
}
